/**
 * R2 images: the API always returns the full public URL directly.
 * This helper just returns the url or falls back gracefully.
 */
export const buildCloudflareImageUrl = (
  _imageId?: string | null,
  _variant?: string,
  fallbackUrl?: string | null
): string => {
  // With R2, the full URL is returned directly from the API as fallbackUrl.
  if (fallbackUrl) return fallbackUrl
  return ''
}
